export default function MEDIAN() {
  return (
    <div className="p-4">
      <h1>MEDIAN</h1>
    </div>
  );
}
